import loadable from '@loadable/component';

export default loadable(
    () => import(/* webpackChunkName: "StyliticWidgetPDP" */ './StyliticWidgetPDP'),
    {
        resolveComponent: (mod) => mod.default,
    }
);
